import { render } from "./AgreementSignTwo.vue?vue&type=template&id=585e673a&scoped=true"
import script from "./AgreementSignTwo.vue?vue&type=script&lang=js"
export * from "./AgreementSignTwo.vue?vue&type=script&lang=js"

import "./AgreementSignTwo.vue?vue&type=style&index=0&id=585e673a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585e673a"]])

export default __exports__